<template>
  <div id="lowPriceOrderList" style="width: 100%; height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top: 0; margin-top: 0" size="medium">
        <el-form-item label="客户：">
          <el-select filterable v-model="searchForm.TC_ID" placeholder="请选择客户" :clearable="true" @change="queryPROJECT">
            <el-option v-for="item in customerList" :key="item.TC_ID" :label="item.TC_AB_NAME" :value="item.TC_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：">
          <el-select filterable v-model="searchForm.PROJECT_ID" @change="getDk" placeholder="请选择项目点" :disabled="!searchForm.TC_ID" clearable>
            <el-option v-for="item in projectList" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：">
          <el-select filterable v-model="searchForm.DK_ID" :disabled="!searchForm.PROJECT_ID" placeholder="请选择档口" clearable>
            <el-option v-for="item in dkList" :key="item.DK_ID" :label="item.DK_NAME" :value="item.DK_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select filterable v-model="searchForm.STATUS" placeholder="请选择状态" clearable>
            <el-option v-for="item in statusList" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态：">
          <el-select filterable v-model="searchForm.APPROVAL_STATUS" placeholder="请选择状态" clearable>
            <el-option v-for="item in approvalStatusList" :key="item.id" :label="item.value" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-col>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" :loading="initLoad">筛选</el-button>
            <el-button @click="addFormVisible = true">录入订单</el-button>
            <el-button type="primary" @click="importOrder" :loading="initLoad">导入</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" border stripe show-summary :summary-method="getSummaries" style="width: 100%">
          <el-table-column prop="ORDER_ID" label="订单ID" width="80"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
          <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口" min-width="70"></el-table-column>
          <el-table-column prop="TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_WEIGHT" label="总重量" min-width="100"></el-table-column>
          <el-table-column label="订单状态" width="100">
            <template slot-scope="scope">
              <el-tag>{{ showOrderStatus(scope.row.ORDER_STATUS) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="100">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.APPROVAL_STATUS == 2">已通过</el-tag>
              <el-tag v-else>未审核</el-tag>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="70">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="queryData" :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper"
          :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-dialog title="选择订单信息" center :visible.sync="addFormVisible" width="600px">
          <el-form :model="addForm" ref="addForm" size="small" class="justifyForm" label-width="90px">
            <el-form-item label="客户名称" prop="TC_ID">
              <el-select filterable v-model="addForm.TC_ID" @change="getAddProject">
                <el-option v-for="item in customerList" :key="item.TC_ID" :label="item.TC_AB_NAME" :value="item.TC_ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目点" prop="PROJECT_ID">
              <el-select filterable v-model="addForm.PROJECT_ID" @change="getAddDk" :disabled="!addForm.TC_ID">
                <el-option v-for="item in addProjectList" :key="item.PROJECT_ID" :label="item.PROJECT_AB_NAME" :value="item.PROJECT_ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="档口" prop="DK_ID">
              <el-select filterable v-model="addForm.DK_ID" :disabled="!addForm.PROJECT_ID">
                <el-option v-for="item in addDkList" :key="item.DK_ID" :label="item.DK_NAME" :value="item.DK_ID"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="送货日期" prop="SEND_DAY">
              <el-date-picker v-model="addForm.SEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <tooltip-button :disabled="addFormComplete" tipContent="请选择订单信息" buttonText="确 定" buttonSize="small" @click="submitAdd">
            </tooltip-button>
          </div>
        </el-dialog>
        <!--   ------------------------------------ 导入模态框-->
        <el-dialog :visible.sync="importOrderDialog" title="导入订单" width="400px" center>
          <el-form ref="orderForm" v-model="importOrderForm">
            <upload-excel-to-json @change="batchImportFileSelected"
              :option="{ header: ['SEND_DAY', 'DK_ID', 'PRODUCT_CODE', 'PRODUCT_COUNT', 'PRICE', 'PRODUCT_COMMENT'] }"
              templateUrl="https://service.linkda.com.cn/file/templates/单外订单导入模板.xlsx" ref="batchCancelUpload">
            </upload-excel-to-json>
          </el-form>
          <div slot="footer" style="text-align: center">
            <el-button class="operate-btn" @click="close">取消</el-button>
            <tooltip-button :disabled="Boolean(batchImportData[0])" buttonText="确认" tipContent="请先选择上传文件" buttonClass="operate-btn"
              @click="submitBatchImport">
            </tooltip-button>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="importErrorDialog" title="错误信息" @close="closeErrorList" width="600px" center>
          <el-table :data="errorList" border stripe style="width: 100%">
            <el-table-column prop="0" label="送货日期" width="120"></el-table-column>
            <el-table-column prop="1" label="档口ID" min-width="70"></el-table-column>
            <el-table-column prop="2" label="错误信息" min-width="270"></el-table-column>
          </el-table>
          <div slot="footer" class="dialog-footer">
            <el-button @click="closeErrorList()">关闭</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>

import * as XLSX from 'xlsx';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      importOrderDialog: false,
      supplierId: Number(sessionStorage.getItem('tcId')),
      customerList: [],
      projectList: [],
      dkList: [],
      importOrderForm: {},
      approvalStatusList: [
        { id: 0, value: '未审核' },
        { id: 2, value: '已通过' },
      ],
      tableData: [],
      fileList: [],
      errorList: [],
      batchImportData: [],
      addProjectList: [],
      addDkList: [],
      addFormVisible: false,
      importErrorDialog: false,
      addForm: {
        TC_ID: null,
        PROJECT_ID: null,
        DK_ID: null,
        SEND_DAY: null,
      },
      initLoad: false,
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      searchForm: {},
      statusList: [
        { NAME: '待送订单', ID: 1 },
        { NAME: '待确认订单', ID: 4 },
        { NAME: '待供应商确认', ID: 6 },
        { NAME: '历史订单', ID: 7 },
      ],
    };
  },
  computed: {
    // 上一次的搜索结果和条件
    LOW_PRICE_ORDER_LIST() {
      return this.$store.state.LOW_PRICE_ORDER_LIST;
    },
    addFormComplete() {
      for (const key in this.addForm) {
        if (!this.addForm[key]) {
          return false;
        }
      }
      return true;
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.LOW_PRICE_ORDER_LIST.CONDITION) {
      this.searchForm = this.LOW_PRICE_ORDER_LIST.CONDITION;
      this.totalCount = this.LOW_PRICE_ORDER_LIST.TOTAL_COUNT;
      this.currentPage = this.LOW_PRICE_ORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    // 获取团餐客户列表
    this.getCustomer();
    this.getProject();
    this.queryData();
  },
  methods: {
    // --------------------客户改变触发
    getCustomer() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 47,
        SUPPLIER_ID: this.supplierId,
      };
      http.post(params).then((res) => {
        this.customerList = res;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 改变客户拉取项目点
    queryPROJECT() {
      this.searchForm.PROJECT_ID = '';
      if (this.searchForm.TC_ID) {
        const params = {
          TC_ID: this.searchForm.TC_ID,
          SERVICE_ID: '10004',
          OTYPE: 48,
          SUPPLIER_ID: this.supplierId,
        };
        http.post(params).then((result) => {
          if (result[0]) {
            this.projectList = result;
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    getProject() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 48,
        SUPPLIER_ID: this.supplierId,
      };
      http.post(params).then((res) => {
        this.projectList = res;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    getDk() {
      if (!this.searchForm.PROJECT_ID) {
        delete this.searchForm.DK_ID;
        return;
      }
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 49,
        SUPPLIER_ID: this.supplierId,
        TC_ID: this.searchForm.TC_ID,
        PROJECT_ID: this.searchForm.PROJECT_ID,
      };
      http.post(params).then((res) => {
        this.dkList = res;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    getAddProject() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 48,
        SUPPLIER_ID: this.supplierId,
        TC_ID: this.addForm.TC_ID,
      };
      http.post(params).then((res) => {
        this.addProjectList = res;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    getAddDk() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 49,
        SUPPLIER_ID: this.supplierId,
        TC_ID: this.addForm.TC_ID,
        PROJECT_ID: this.addForm.PROJECT_ID,
      };
      http.post(params).then((res) => {
        this.addDkList = res;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 单外订单导入
    importOrder() {
      this.importOrderDialog = true;
    },
    submitAdd() {
      sessionStorage.setItem('addLowPriceOrderTitle', JSON.stringify({
        ...this.addForm,
        CUSTOMER_NAME: this.customerList.find((item) => item.TC_ID == this.addForm.TC_ID).TC_NAME,
        PROJECT_NAME: this.addProjectList.find((item) => item.PROJECT_ID == this.addForm.PROJECT_ID).PROJECT_NAME,
        DK_NAME: this.addDkList.find((item) => item.DK_ID == this.addForm.DK_ID).DK_NAME,
      }));
      this.$router.push({ path: '/addLowPriceOrder/detail' });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (!['REAL_TOTAL_SUPPLIER_FEE', 'REAL_TOTAL_WEIGHT', 'TOTAL_SUPPLIER_FEE', 'TOTAL_WEIGHT'].includes(column.property)) {
          return;
        }
        const values = data.map((item) => Number(item[column.property])); // 总价列的数组
        if (!values.every((value) => Number.isNaN(value))) {
          // 判断当前列有无NaN  ，有则直接这一列合计为 '--'
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr); // 防止是字符串累加
            if (!Number.isNaN(value)) {
              return prev + value;
            }
            return prev;
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 关闭导入错误模态框
    closeErrorList() {
      this.importErrorDialog = false;
      this.errorList = [];
    },
    detail(row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      this.$router.push({ path: '/lowPriceOrderListDetail/detail' });
    },
    // -----------------------获取新订单列表
    queryData() {
      const params = {
        SERVICE_ID: '10004',
        OTYPE: 45,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DK_ID) {
        params.DK_ID = this.searchForm.DK_ID;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        [params.START_DAY, params.END_DAY] = this.searchForm.DAY_INTERVAL;
      }
      if (this.searchForm.STATUS) {
        params.STATUS = this.searchForm.STATUS;
      }
      if (this.searchForm.APPROVAL_STATUS) {
        params.APPROVAL_STATUS = this.searchForm.APPROVAL_STATUS;
      }
      this.initLoad = true;
      http.post(params).then((result) => {
        if (result.length != 0) {
          this.tableData = result.length > 0 ? result[0].LIST : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
          // 将搜索结果和条件存储到vuex中
          this.$store.dispatch('SET_LOW_PRICE_ORDER_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
            TOTAL_COUNT: this.totalCount,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        this.initLoad = false;
      }).catch((error) => {
        this.initLoad = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close() {
      this.importOrderDialog = false;
      this.fileList = [];
      this.addFormVisible = false;
      this.$refs.addForm.resetFields();
    },
    batchImportFileSelected(e) {
      this.batchImportData = e.map(({
        SEND_DAY, DK_ID, PRODUCT_CODE, PRODUCT_COUNT, PRICE, PRODUCT_COMMENT,
      }) => ({
        SEND_DAY, DK_ID, PRODUCT_CODE, PRODUCT_COUNT, PRICE, PRODUCT_COMMENT,
      })).slice(1);
    },
    async submitBatchImport() {
      const isValidData = this.batchImportData.map(({
        SEND_DAY, DK_ID, PRODUCT_CODE, PRODUCT_COUNT, PRICE, PRODUCT_COMMENT,
      }) => {
        const errors = [];
        if (!validation.dateValidate(SEND_DAY)) {
          errors.push('送货日期输入不正确');
        }
        if (!validation.数量整数正数验证(DK_ID)) {
          errors.push('档口ID输入不正确');
        }

        if (!validation.数量整数正数验证(PRODUCT_CODE)) {
          errors.push('产品编码输入不正确');
        }

        if (!validation.数量正数验证(PRODUCT_COUNT)) {
          errors.push('数量输入不正确');
        }

        if (!validation.价格正数验证(PRICE)) {
          errors.push('采购价输入不正确');
        }
        const REASON = errors.length > 0 ? errors.join(',') : null; // 将错误数组中的字符串拼接成一行文字，或者将REASON置为空
        return {
          SEND_DAY, // 将日期对象转换为字符串格式 yyyy-mm-dd
          DK_ID,
          PRODUCT_CODE: PRODUCT_CODE.toString(), // 将PRODUCT_CODE转换为字符串以保持完整长度
          PRODUCT_COUNT,
          PRICE,
          PRODUCT_COMMENT,
          REASON,
        };
      });
      if (!isValidData.every(({ REASON }) => !REASON)) {
        this.$message.show({ text: '导入信息有误,请查看结果', type: 'warning' });
        // 这里我要下载
        const Writeheader = ['送货日期', '档口ID', '产品编码', '数量', '采购价', '备注', '错误原因'];
        // 创建一个新表
        const ws = XLSX.utils.aoa_to_sheet([Writeheader, ...isValidData.map(({ reason, ...rest }) => Object.values(rest))]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, '导出结果.xlsx');
        this.$message.show({ text: '导入信息有误,请查看结果', type: 'warning' });
        return false;
      }
      const mergedData = [];
      isValidData.forEach((curr) => {
        const existingOrderIndex = mergedData.findIndex((item) => item.SEND_DAY === curr.SEND_DAY && item.DK_ID === curr.DK_ID);
        // findIndex 不符合会返回 -1
        if (existingOrderIndex !== -1) {
          const existingOrder = mergedData[existingOrderIndex];
          const productIndex = existingOrder.PRODUCTS.findIndex((product) => product.PRODUCT_CODE === curr.PRODUCT_CODE && product.PRICE === curr.PRICE);
          if (productIndex !== -1) {
            existingOrder.PRODUCTS[productIndex].PRODUCT_COUNT += curr.PRODUCT_COUNT;
          } else {
            existingOrder.PRODUCTS.push({
              PRODUCT_CODE: curr.PRODUCT_CODE,
              PRICE: curr.PRICE,
              PRODUCT_COUNT: curr.PRODUCT_COUNT,
              PRODUCT_COMMENT: curr.PRODUCT_COMMENT || '',
            });
          }
        } else {
          mergedData.push({
            SEND_DAY: curr.SEND_DAY,
            DK_ID: curr.DK_ID,
            PRODUCTS: [{
              PRODUCT_CODE: curr.PRODUCT_CODE,
              PRICE: curr.PRICE,
              PRODUCT_COUNT: curr.PRODUCT_COUNT,
              PRODUCT_COMMENT: curr.PRODUCT_COMMENT || '',
            }],
          });
        }
      });
      const paramsList = [];
      let errorText = [];
      let flag = 0;
      mergedData.forEach((item, index) => {
        paramsList.push({
          SERVICE_ID: '10004',
          OTYPE: 46,
          DK_ID: item.DK_ID,
          SEND_DAY: item.SEND_DAY,
          PRODUCT_LIST: item.PRODUCTS,
          SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        });
      });
      for (const item of paramsList) {
        try {
          const _res = await http.post(item);
        } catch (e) {
          flag = 2;
          if (e.includes('订单中存在相同产品')) {
            const SEND_DAY = item.SEND_DAY; // 获取sendday的值
            const DK_ID = item.DK_ID;
            const errorInfo = [SEND_DAY, DK_ID, e]; // includes判断后 e应该都是相同的
            this.errorList.push(errorInfo);
          } else {
            errorText = e;
          }
        }
        if (flag == 0) {
          this.$message.show({ text: '单外订单导入成功', type: 'success' });
        } else {
          if (this.errorList.length > 0) {
            this.$message.show({ text: '部分导入错误', type: 'error' });
            this.importErrorDialog = true;
          } else {
            this.$message.show({ text: errorText, type: 'error' });
          }
        }
      }
      this.queryData();
    },

    // ----------------------------------------点击筛选按钮触发
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    showOrderStatus: util.showOrderStatus,


  },
};
</script>
<style scoped>
.justifyForm >>> .el-form-item__label {
  text-align-last: justify;
}

.justifyForm >>> .el-input,
.el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/lowPriceOrderList.vue